import * as React from "react";
const SvgVisa = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 55,
	height: 24,
	fill: "none",
	viewBox: "0 0 55 24",
	id: "visa_icon",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "#1434CB",
	d: "M35.835 3c-3.9 0-7.402 2.054-7.402 5.824 0 4.34 6.186 4.637 6.186 6.797 0 .91-1.049 1.737-2.81 1.737-2.516 0-4.403-1.144-4.403-1.144l-.797 3.812s2.16.974 5.053.974c4.278 0 7.633-2.139 7.633-5.993 0-4.574-6.207-4.87-6.207-6.882 0-.72.86-1.504 2.621-1.504 1.992 0 3.628.826 3.628.826l.796-3.685c-.02 0-1.803-.762-4.298-.762m-35.73.275L0 3.825s1.636.297 3.124.911c1.908.7 2.034 1.102 2.37 2.351l3.501 13.616h4.697l7.192-17.428H16.21l-4.634 11.86-1.888-10.06c-.167-1.143-1.048-1.8-2.138-1.8zm22.667 0-3.67 17.428h4.466l3.649-17.428zm24.868 0c-1.07 0-1.635.572-2.055 1.589l-6.542 15.84h4.676l.902-2.648h5.703l.545 2.647H55L51.414 3.275zm.608 4.723 1.384 6.543h-3.711z"
}));
export { SvgVisa as ReactComponent };
